export function getAgencyId(agency) {
  return String(agency?._id || agency || '');
}

export function getTaskAssigneeAgencyId(transport, selectedAgencyId) {
  if (transport?.sharedAgency) {
    return getAgencyId(transport.sharedAgency);
  }
  return getAgencyId(transport?.agency) || getAgencyId(selectedAgencyId);
}

export function isOutgoingShared(transport, selectedAgencyId) {
  if (!selectedAgencyId || !transport?.sharedAgency) return false;
  return getAgencyId(transport.agency) === String(selectedAgencyId);
}

export function isIncomingShared(transport, selectedAgencyId) {
  if (!selectedAgencyId || !transport?.sharedAgency) return false;
  const sharedId = getAgencyId(transport.sharedAgency);
  return sharedId === String(selectedAgencyId)
    && getAgencyId(transport.agency) !== String(selectedAgencyId);
}

export function getSharedOwnerAgencyName(transport) {
  return transport?.agency?.name || '';
}

export function getPairedAgencyName(transport) {
  return transport?.pairedTransport?.agency?.name || '';
}

export function getPairedTransportNumber(transport) {
  return transport?.pairedTransport?.number || '';
}
